
  var collections = { 'his': [], 'her': [] };
  var callbackSelects = [];
  
  var selectCallback = function(variant, selector) {

        if (variant) {
            $('.variant-sku').text(variant.sku);
        }
        else {
            $('.variant-sku').empty();
        }

        if (variant) {
            
            // Selected a valid variant that is available.
            if (variant.available) {
              // if(document.querySelector('.his-prods-1 .prod-caption .gift-guide-input')) document.querySelector('.his-prods-1 .prod-caption .gift-guide-input').value = variant.id;
                // if(document.querySelector('.his-prods-2 .prod-caption .gift-guide-input'))document.querySelector('.his-prods-2 .prod-caption .gift-guide-input').value = variant.id;
              //  if(document.querySelector('.his-prods-3 .prod-caption .gift-guide-input')) document.querySelector('.his-prods-3 .prod-caption .gift-guide-input').value = variant.id;
              //   if(document.querySelector('.his-prods-4 .prod-caption .gift-guide-input'))document.querySelector('.his-prods-4 .prod-caption .gift-guide-input').value = variant.id;
                
                // document.querySelector('.her-prods-1 .prod-caption .gift-guide-input').value = variant.id;
                // document.querySelector('.her-prods-1 .prod-caption .gift-guide-input').value = variant.id;
                // document.querySelector('.her-prods-1 .prod-caption .gift-guide-input').value = variant.id;
                // document.querySelector('.her-prods-1 .prod-caption .gift-guide-input').value = variant.id;
              // Enabling add to cart button.
              var btn = $(selector.variantIdField).parent().parent().find(".giftGuideModalAdd")[0] || $(selector.variantIdField).parent().parent().find("[type='submit']")[0];
              $(btn).css('background', '#d4363a').prop('disabled', false).text("Add to Cart").val("Add to Cart");

            } else {
                // Variant is sold out.
              // console.log($(selector.variantIdField).parent().parent());
              var btn = $(selector.variantIdField).parent().parent().find(".giftGuideModalAdd")[0] || $(selector.variantIdField).parent().parent().find("[type='submit']")[0];
              // console.log(btn);
              $(btn).text("Sold Out").val("Sold Out").css("background", "#999").prop('disabled', true);
            }

            var priceBox = $(selector.variantIdField).parent().parent().find(".product-price-box")[0]
            // Whether the variant is in stock or not, we can update the price and compare at price.
            if ( variant.compare_at_price > variant.price ) {
                $(priceBox).html('<span class="product-price on-sale">'+ Shopify.formatMoney(variant.price, "") +'</span>'+'&nbsp;<s class="product-compare-price">'+Shopify.formatMoney(variant.compare_at_price, "")+ '</s>');
            } else {
                $(priceBox).html('<span class="product-price">'+ Shopify.formatMoney(variant.price, "") + '</span>' );
            }

        } else {
            // variant doesn't exist.
            jQuery('#product-price').empty();
            var btn = $(selector.variantIdField).parent().parent().find(".giftGuideModalAdd")[0] || $(selector.variantIdField).parent().parent().find("[type='submit']")[0];
            $(btn).text("Unavailable").val("Unavailable").css("background", "#999").prop('disabled', true);
        }

    };